import { apiUrl } from "util/config";
import { message } from "antd";

import $ from "jquery";
//updateMyCartTraining
var Actions = {
  getPurchase: page => {
    // page = page > 0 ? page - 1 : page;
    return new Promise((resolve, reject) => {
      var settings = {
        async: true,
        crossDomain: true,
        url: apiUrl + "api/purchase/training",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
          // fngprt: m.cookie.get("fngprt")
        },
        data: { page },
        success: function(response) {
          if (response.error) {
            message.error(response.userMessage);
          } else {
            resolve(response);
          }
        },
        error: function(error) {
          if (error.status == 401) {
            message.error("Your session has been expired. Please relogin.");
            localStorage.clear();window.location.reload();
          } else {
            message.error("Some error has occurred.");
          }
        }
      };

      $.ajax(settings).done();
    });
  }
};

export default Actions;
